import type { SlotName } from "../../../config/platforms/types";
import { InfoIcon } from "./InfoIcon";

export interface AdvertisementInfoProps {
  behalf: PrebidDsaObject["behalf"] | null;
  paid: PrebidDsaObject["paid"] | null;
}

export interface AdvertisementLabelProps extends AdvertisementInfoProps {
  slot: SlotName;
}

export class AdvertisementLabel {
  constructor(private readonly props: AdvertisementLabelProps) {}

  translatedAdLabel = document.querySelector(
    ".ae-translatable-label",
  ) as HTMLElement;

  render(): HTMLDivElement {
    const { behalf, paid } = this.props;
    const icon = new InfoIcon({ behalf, paid }).render();

    return (
      <div
        className="ae-translatable-label advertisement-label"
        id={"label-" + this.props.slot}
      >
        <span className="dsa-advertisement-label-clickable">
          {this.translatedAdLabel
            ? this.translatedAdLabel.innerText
            : "Advertisement "}
          {icon}
        </span>
      </div>
    );
  }
}
